import { useEffect, useState } from "react";
import { useFutureCallback } from "./hooks/useFutureCallback";
import { Input } from "./Input";
import { cn } from "@repo/shared/utils";

export function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  className,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange">) {
  const [value, setValue] = useState(initialValue);

  // preserve handler value in case parent component's onChange sets state
  // (this would re-render it and pass a new handler, triggering delayed recursion)
  const changeHandler = useFutureCallback(onChange);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      changeHandler(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, debounce, changeHandler]);

  return (
    <Input
      id={props.id ?? "filterInput"}
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      className={cn("p-0.5", className)}
    />
  );
}
